import { ConfigInterface } from 'swr';
import { api, parseUrl, useApi } from '@gik/core/api';
import { BaseUserWithLocation, User } from '@gik/core/models/gik/User';

// TODO: remove when .net core auth functionality is available
declare const window: LegacyReactWindow;

const path = 'users';

export async function getUser(id: string): Promise<User> {
  const finalUrl = parseUrl(`${path}/${id}`);
  return (await (await api.get(finalUrl)).json()) as User;
}

export function useUser(id?: string, config?: ConfigInterface) {
  return useApi<User>(id ? `${path}/${id}` : null, config);
}

export async function updateUser(id: string, user: BaseUserWithLocation): Promise<void> {
  await api.put(`users/${id}`, {
    json: user,
  });
}

export async function updateUserAvatar(id: string, data: Blob): Promise<{ avatar_url: string }> {
  try {
    const response = await api.put(`users/${id}/avatar`, {
      body: data,
    });

    return await response.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateUserWelcomeScreenLastSeen(userId: string): Promise<void> {
  await api.put(`users/${userId}/welcomeScreenLastSeen`);
}

export async function updateUserSeenPremiumPageReminders(userId: string, inkindRouteId: string): Promise<void> {
  await api.put(`users/${userId}/seenPremiumPageReminders/${inkindRouteId}`);
}

export async function deleteUser(userId: string): Promise<void> {
  await api.delete(`users/${userId}`);
}

export async function removeFavoriteArticle(userId: string, articleId): Promise<void> {
  await api.delete(`users/${userId}/favorites/${articleId}?type=articles`);
}

export async function removeFavoriteProduct(userId: string, productId): Promise<void> {
  await api.delete(`users/${userId}/favorites/${productId}?type=products`);
}

export async function removeOrUnfollowPage(userId: string, routeId: string): Promise<void> {
  await api.delete(`users/${userId}/inkinds/${routeId}`);
}

export async function followPage(userId: string, routeId: string): Promise<void> {
  await api.post(`users/${userId}/inkinds`, {
    json: { routeId },
  });
}
